import { NumberParam, useQueryParam } from 'use-query-params';
import { NumberInput } from '../../../../components/shared/input/Input';
import { QueryParamNames } from '../../enums/QueryParamNames';

export function DurationFilter() {
    const [minDuration, setMinDuration] = useQueryParam(QueryParamNames.MIN_DURATION, NumberParam);
    const [maxDuration, setMaxDuration] = useQueryParam(QueryParamNames.MAX_DURATION, NumberParam);

    return (
        <div className='col-span-12 sm:col-span-6 lg:col-span-4 xl:col-span-2'>
            <p>Duration:</p>
            <div className='flex items-center'>
                <NumberInput min='0' value={minDuration ?? null} onChange={setMinDuration} />
                <p className='m-0 mx-2'>to</p>
                <NumberInput min='0' value={maxDuration ?? null} onChange={setMaxDuration} />
            </div>
        </div>
    );
}
